/* eslint-disable no-shadow */
import { forwardRef } from 'react';
import { Accordion } from 'react-bootstrap';
import {SortableContainer, SortableElement} from 'react-sortable-hoc';
import ProductItem from './product-item';

const CategoryAccordion = ({
  categories, itemName, statusAttribute, ...props
}) => {
  const ProductListSortable = SortableContainer(forwardRef(({
    items, itemType, categoryName, statusAttribute
  }, ref) => (
    <div ref={ref}>
      {
        items.map((item, index) => (
          <ProductSortable
            categoryName={categoryName}
            index={index}
            item={item}
            itemType={itemType}
            key={index}
            statusAttribute={statusAttribute}
          />
        ))
      }
    </div>
  )));

  const ProductSortable = SortableElement(forwardRef(({
    item, itemType, categoryName, statusAttribute
  }, ref) => (
    <ProductItem
      ref={ref}
      categoryName={categoryName}
      deleteDisabled={item.has_products}
      image={item.links.image}
      item={item}
      itemType={itemType}
      key={item.id}
      status={item[statusAttribute]}
      {...props}
    />
  )));

  const handleSort = (categoryId, brandId, {oldIndex, newIndex}) => {
    props.onSortEnd(categoryId, brandId, oldIndex, newIndex);
  };

  return (
    <Accordion>
      {
        categories.map((category, categoryKey) => {
          if (itemName === 'brands') {
            const key = `${category.id}`;
            const {name} = category.attributes;

            return (
              <Accordion.Item eventKey={key} key={key}>
                <Accordion.Header>{name}</Accordion.Header>
                <Accordion.Body>
                  <ProductListSortable
                    helperClass="product-reordering"
                    items={category.attributes[itemName]}
                    itemType="Brand"
                    lockAxis="y"
                    onSortEnd={(...params) => handleSort(category.id, undefined, ...params)}
                    pressDelay={50}
                    statusAttribute={statusAttribute}
                  />
                </Accordion.Body>
              </Accordion.Item>
            );
          } else if (itemName === 'products') {
            return category.attributes.brands.map((brand) => {
              const key = `${category.id}-${brand.id}`;
              const name = `${brand.name} - ${category.attributes.name}`;

              return (
                <Accordion.Item eventKey={key} key={key}>
                  <Accordion.Header>{name}</Accordion.Header>
                  <Accordion.Body>
                    <ProductListSortable
                      categoryName={category.attributes.name}
                      helperClass="product-reordering"
                      items={brand[itemName]}
                      itemType="Product"
                      lockAxis="y"
                      onSortEnd={(...params) => handleSort(category.id, brand.id, ...params)}
                      pressDelay={150}
                      statusAttribute={statusAttribute}
                    />
                  </Accordion.Body>
                </Accordion.Item>
              );
            });
          }

          return <div key={categoryKey}/>;
        })
      }
    </Accordion>
  );
};

export default CategoryAccordion;

// <CategorySortable key={`item-${index}`} index={index} value={value}/>
